import { IApplicationState, TCardId } from '../../../../../../../../types/types';
import { getCustomProperties } from '../../selectors/getCustomProperties';
import { getBoardIdByCardId } from '../../../../../../../../store/model/selectors/getBoardIdByCardId';
import { ECustomPropertyType } from '../../../../../../../../store/customProperties/types';

export const getCategoriesActions = (
    state: IApplicationState,
    cardId: TCardId,
) => {
    const res: { name: string, id: string }[] = [];
    getCustomProperties(state, getBoardIdByCardId(state, cardId), cardId)
        .forEach(property => {
            if (property.type === ECustomPropertyType.DATE && property.value) {
                res.push({
                    name: property.name,
                    id: String(property.id),
                });
            }
        });
    return res;
};
